var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRes),expression:"showRes"}],staticStyle:{"position":"absolute","display":"none","z-index":"auto","height":"100%"}},[_c('canvas',{attrs:{"id":"myCanvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }